<script>
    import { getContext } from 'svelte';
    import { writable } from 'svelte/store';

    export let dataKey;
    export let projection;
    export const handles = { show, highlight, hide };
    const { query, aql, car } = getContext(dataKey);

    const r = 2;
    const opacity = 1;

    let flag = false;
    const gps_trace = writable([]);
    const highlight_idx = writable(0);
    function show(movement) {
        query(
            aql`
            LET trajectory = (
                FOR t IN raw_gps
                    FILTER t.id == ${$car}
                    FILTER t.timestamp >= ${movement.start.timestamp}
                    FILTER t.timestamp <= ${movement.stop.timestamp}
                    SORT t.timestamp
                    RETURN {lat: t.lat, long: t.long, time: t.timestamp}
            )
            LET stride = max([round(length(trajectory) / 50), 1])
            FOR i IN 0..(length(trajectory)/stride)
                RETURN trajectory[i*stride]
        `,
            gps_trace,
            (res) => {
                const coords = res
                    .filter((p) => p)
                    .map((p) => {
                        const coord = projection([p.long, p.lat]);
                        coord.t = p.time;
                        return coord;
                    });
                return coords;
            }
        );
        flag = true;
    }

    function hide() {
        flag = false;
    }

    function highlight(time) {
        $highlight_idx = $gps_trace.findIndex((c) => c.t >= time);
    }
</script>

<g>
    {#if flag}
        {#each $gps_trace as coord, i}
            <circle
                cx={coord[0]}
                cy={coord[1]}
                r={i == $highlight_idx ? 5 : r}
                {opacity}
                fill="skyblue"
            />
        {/each}
    {/if}
</g>
